import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "common/locales";
import { SEEDING_METHOD, SEEDING_METHOD_OPTIONS } from "model";

interface SeedingMethodDropdownProps {
  seedingMethod: string;
  onChange: (value?: SEEDING_METHOD) => void;
  seedingMethodInputError: boolean;
  label: string;
}

export default function SeedingMethodDropdown({
  onChange,
  seedingMethod,
  seedingMethodInputError,
  label,
}: SeedingMethodDropdownProps) {
  const { t } = useTranslation();

  return (
    <TextField
      select
      fullWidth
      value={seedingMethod ?? ""}
      onChange={(e) => onChange(e.target.value as SEEDING_METHOD | undefined)}
      error={seedingMethodInputError}
      label={t(label)}
      InputLabelProps={{ shrink: true }}
      SelectProps={{
        displayEmpty: true,
      }}
    >
      <MenuItem value="" disabled>
        <em>{t("reseedEvent.seedingMethod.placeholder")}</em>
      </MenuItem>
      {SEEDING_METHOD_OPTIONS.map((value) => (
        <MenuItem value={value} key={value}>
          {t(`reseedEvent.seedingMethod.option.${value}`)}
        </MenuItem>
      ))}
    </TextField>
  );
}
